'use client';

import type { HTMLAttributes, ReactNode } from 'react';

export function Card({ flush, className, children, ...rest }: HTMLAttributes<HTMLDivElement> & { flush?: boolean }) {
  const cls = ['mx-card', flush && 'mx-card--flush', className].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}

export function Empty({
  icon,
  title,
  children,
  action,
}: {
  icon?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="mx-empty">
      {icon && <div className="mx-empty__icon">{icon}</div>}
      {title != null && (
        <h3 className="mx-h3" style={{ marginBottom: 6 }}>
          {title}
        </h3>
      )}
      {children != null && <p className="mx-body">{children}</p>}
      {action && <div style={{ marginTop: 'var(--mx-sp-4)' }}>{action}</div>}
    </div>
  );
}
